import { businessKey } from 'queryKeys';

const CAMPAIGNS = 'campaigns';
const COST_MODEL = 'costModel';
const LANDINGS = 'landings';
const MEDIA_SOURCE = 'mediaSource';

const MUTATION_CHANGE_OWNERS = 'changeOwners';
const MUTATION_ADD_PROMO_CODES = 'addPromoCodes';
const MUTATION_EXPORT = 'exportCMN';
const MUTATION_UPDATE_COST_MODEL = 'updateCostModel';
const MUTATION_EXPORT_UPDATED_CFF_COST_TEMPLATE =
  'exportUpdatedCampaignCffCostTemplate';
const MUTATION_EXPORT_LINKS = 'exportCMNLinks';
const MUTATION_GENERATE_LINKS = 'generateCMNLinks';
const MUTATION_UPLOAD_NEW_CAMPAIGNS = 'uploadNewCampaigns';
const MUTATION_UPLOAD_UPDATED_CAMPAIGNS = 'uploadUpdatedCampaigns';
const MUTATION_CREATE_MEDIA_SOURCE = 'createMediaSource';
const MOVE_TO_ANOTHER_AFFILIATE = 'moveToAnotherAffiliate';
const STATUS_CHANGE_CONFIRMATION = 'statusChangeConfirmation';
const cmpnQuery = businessKey.query(CAMPAIGNS);

export const grids = cmpnQuery.grids();
export const grid = cmpnQuery.grid();
export const exact = cmpnQuery.exact();
export const costModel = cmpnQuery.exact(COST_MODEL);
export const landings = cmpnQuery.exact(LANDINGS);
export const mediaSource = cmpnQuery.exact(MEDIA_SOURCE);

export const details = cmpnQuery.details();
export const mutations = cmpnQuery.mutations();

export const activate = mutations.activate();
export const archive = mutations.archive();
export const update = mutations.update();
export const create = mutations.create();

export const statusChangeConfirmation = mutations.mutate(
  STATUS_CHANGE_CONFIRMATION
);
export const moveToAnotherAffiliate = mutations.mutate(
  MOVE_TO_ANOTHER_AFFILIATE
);
export const updateCM = mutations.mutate(MUTATION_UPDATE_COST_MODEL);
export const exportCMN = mutations.mutate(MUTATION_EXPORT);
export const exportCMNLinks = mutations.mutate(MUTATION_EXPORT_LINKS);
export const uploadNewCMNs = mutations.mutate(MUTATION_UPLOAD_NEW_CAMPAIGNS);
export const uploadUpdatedCMNs = mutations.mutate(
  MUTATION_UPLOAD_UPDATED_CAMPAIGNS
);
export const generateCMNLinks = mutations.mutate(MUTATION_GENERATE_LINKS);
export const batchAddPromoCodes = mutations.mutate(MUTATION_ADD_PROMO_CODES);
export const updateOwners = mutations.mutate(MUTATION_CHANGE_OWNERS);

export const exportUpdatedInfluencerCampaignsTemplate = mutations.mutate(
  MUTATION_EXPORT_UPDATED_CFF_COST_TEMPLATE
);

export const createMS = mutations.mutate(MUTATION_CREATE_MEDIA_SOURCE);
